module.exports = __webpack_public_path__ + "img/schedule-left-icon.0e4a153a.svg";